import { AxiosResponse } from 'axios';
import AxiosInstanceBFF from './AxiosInstanceBFF';

export const deleteBusinessHoursSchedules = async (id: string, deletedBy: string): Promise<AxiosResponse<[]>> =>
  AxiosInstanceBFF.delete(`v1/business-hours/${id}?deletedBy=${deletedBy}`);
